import { render, staticRenderFns } from "./SectionChallenge.component.vue?vue&type=template&id=c99f5c02&"
import script from "./SectionChallenge.component.vue?vue&type=script&lang=js&"
export * from "./SectionChallenge.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports